/* GENERATED by Challenges/build/export_training_guides.py. Do not hand-edit:
   rebuild a challenge spec and re-run the exporter, or your change is lost.
   Every link points at assets/guide-<slug>.html#level-N. */
export const GUIDE_SKILLS = [
  {
    "skill": "ABS",
    "gloss": "The size of a number, ignoring its sign",
    "slug": "sprint-grid-distance",
    "level": 2,
    "levelName": "Grid steps between two cities",
    "core": false,
    "alsoIn": [],
    "uses": 1
  },
  {
    "skill": "ABSOLUTE.REF",
    "gloss": "The $ signs: pin a row, a column, or both, so a formula survives being filled",
    "slug": "sprint-anchors",
    "level": 1,
    "levelName": "One cell that must not move",
    "core": false,
    "alsoIn": [],
    "uses": 4
  },
  {
    "skill": "ADDRESS",
    "gloss": "Build a cell address like $B$7 out of a row and column number",
    "slug": "indirect",
    "level": 2,
    "levelName": "When all you have is numbers",
    "core": true,
    "alsoIn": [],
    "uses": 1
  },
  {
    "skill": "AND",
    "gloss": "True only when every condition is true",
    "slug": "sprint-if-logic",
    "level": 2,
    "levelName": "Only if they also kept returns down",
    "core": true,
    "alsoIn": [],
    "uses": 2
  },
  {
    "skill": "AVERAGEIFS",
    "gloss": "Average only the rows that meet several conditions",
    "slug": "sprint-ifs-family",
    "level": 3,
    "levelName": "The average, to the nearest whole",
    "core": true,
    "alsoIn": [],
    "uses": 1
  },
  {
    "skill": "BYROW",
    "gloss": "Run one calculation once per row and get one answer per row back",
    "slug": "let-byrow",
    "level": 4,
    "levelName": "BYROW: the LAMBDA runs once per row",
    "core": true,
    "alsoIn": [],
    "uses": 7
  },
  {
    "skill": "CHAR",
    "gloss": "The character with a given code number, used as a marker nothing else uses",
    "slug": "find-startnum",
    "level": 4,
    "levelName": "The Nth one, without nesting forever",
    "core": true,
    "alsoIn": [],
    "uses": 2
  },
  {
    "skill": "CHOOSECOLS",
    "gloss": "Pick particular columns out of an array",
    "slug": "scan",
    "level": 2,
    "levelName": "Reading one day out of the series",
    "core": true,
    "alsoIn": [
      "sb-every-xth",
      "sprint-wrap"
    ],
    "uses": 7
  },
  {
    "skill": "CHOOSEROWS",
    "gloss": "Pick particular rows out of an array",
    "slug": "sb-every-xth",
    "level": 4,
    "levelName": "Down the columns with WRAPCOLS",
    "core": true,
    "alsoIn": [
      "sprint-wrap"
    ],
    "uses": 3
  },
  {
    "skill": "COLUMNS",
    "gloss": "How many columns wide is this, which is how you measure what a formula spilled",
    "slug": "sprint-textsplit",
    "level": 2,
    "levelName": "How many pieces",
    "core": false,
    "alsoIn": [
      "text-modern"
    ],
    "uses": 3
  },
  {
    "skill": "CONCAT",
    "gloss": "Glue text together, including a whole range at once",
    "slug": "sprint-join",
    "level": 3,
    "levelName": "Point at the whole range",
    "core": true,
    "alsoIn": [],
    "uses": 1
  },
  {
    "skill": "CONCAT.AMP",
    "gloss": "Glue text together with &, the operator version of joining",
    "slug": "sprint-join",
    "level": 1,
    "levelName": "Join two of them",
    "core": false,
    "alsoIn": [
      "sprint-explode"
    ],
    "uses": 2
  },
  {
    "skill": "CONCATENATE",
    "gloss": "The older way to glue text together, one argument per piece",
    "slug": "sprint-join",
    "level": 2,
    "levelName": "The same job with a name",
    "core": true,
    "alsoIn": [],
    "uses": 1
  },
  {
    "skill": "COUNTA",
    "gloss": "Count how many cells are not empty",
    "slug": "unique-filter",
    "level": 4,
    "levelName": "COUNTA(UNIQUE(...)): counting DIFFERENT things",
    "core": false,
    "alsoIn": [
      "sprint-arrays-1",
      "sprint-arrays-2"
    ],
    "uses": 7
  },
  {
    "skill": "COUNTIF",
    "gloss": "Count the rows that meet one condition",
    "slug": "countifs",
    "level": 1,
    "levelName": "One condition",
    "core": true,
    "alsoIn": [],
    "uses": 3
  },
  {
    "skill": "COUNTIFS",
    "gloss": "Count the rows that meet several conditions at once",
    "slug": "countifs",
    "level": 3,
    "levelName": "Two conditions",
    "core": true,
    "alsoIn": [
      "argmax",
      "index-match",
      "sprint-ifs-family",
      "sumproduct",
      "time-windows"
    ],
    "uses": 17
  },
  {
    "skill": "FILTER",
    "gloss": "Keep only the rows that match, and drop the rest",
    "slug": "unique-filter",
    "level": 1,
    "levelName": "FILTER: pull the rows, then total them",
    "core": true,
    "alsoIn": [
      "let-byrow",
      "sort-sortby",
      "sprint-arrays-1",
      "sprint-arrays-2",
      "sprint-arrays-3",
      "sprint-sort-3a",
      "sprint-sort-4a",
      "sprint-wrap"
    ],
    "uses": 33
  },
  {
    "skill": "FIND",
    "gloss": "Where does this text start, counting from character 1",
    "slug": "find-startnum",
    "level": 1,
    "levelName": "Where is the first one",
    "core": true,
    "alsoIn": [
      "sprint-find",
      "sprint-substitute",
      "text-parse"
    ],
    "uses": 15
  },
  {
    "skill": "HOUR",
    "gloss": "Pull the hour out of a time",
    "slug": "time-windows",
    "level": 1,
    "levelName": "What hour is this",
    "core": true,
    "alsoIn": [],
    "uses": 3
  },
  {
    "skill": "IF",
    "gloss": "Do one thing when a condition holds and another when it does not",
    "slug": "sprint-if-logic",
    "level": 1,
    "levelName": "Pay, plus a bonus if they hit target",
    "core": true,
    "alsoIn": [
      "sprint-reduce"
    ],
    "uses": 5
  },
  {
    "skill": "IFERROR",
    "gloss": "If this formula errors, use that instead",
    "slug": "sumproduct",
    "level": 9,
    "levelName": "A window, blank-safe",
    "core": false,
    "alsoIn": [
      "text-modern",
      "text-parse"
    ],
    "uses": 5
  },
  {
    "skill": "INDEX",
    "gloss": "Give me the nth item from a list, or the cell at row n column m",
    "slug": "index-match",
    "level": 1,
    "levelName": "INDEX with a row number",
    "core": true,
    "alsoIn": [
      "argmax",
      "datatable-sequence",
      "sb-every-xth",
      "sort-large",
      "sort-sortby",
      "sprint-anchors",
      "sprint-arrays-1",
      "sprint-arrays-2",
      "sprint-arrays-3",
      "sprint-index2d",
      "sprint-lookup-1",
      "sprint-lookup-2",
      "sprint-sort-1a",
      "sprint-sort-2a",
      "sprint-sort-3a",
      "sprint-sort-4a",
      "sprint-textsplit",
      "sprint-transpose",
      "text-modern",
      "unique-filter"
    ],
    "uses": 63
  },
  {
    "skill": "INDIRECT",
    "gloss": "Turn text into a real cell reference you can read from",
    "slug": "indirect",
    "level": 1,
    "levelName": "Text into a reference",
    "core": true,
    "alsoIn": [
      "sprint-indirect"
    ],
    "uses": 14
  },
  {
    "skill": "ISODD",
    "gloss": "TRUE for an odd number, handy for alternating rows",
    "slug": "sprint-wrap",
    "level": 4,
    "levelName": "The snake",
    "core": false,
    "alsoIn": [],
    "uses": 1
  },
  {
    "skill": "LAMBDA",
    "gloss": "Write a small function of your own, inline",
    "slug": "let-byrow",
    "level": 4,
    "levelName": "BYROW: the LAMBDA runs once per row",
    "core": true,
    "alsoIn": [
      "scan",
      "sprint-reduce"
    ],
    "uses": 15
  },
  {
    "skill": "LARGE",
    "gloss": "The nth biggest value, not just the biggest",
    "slug": "sort-large",
    "level": 1,
    "levelName": "LARGE: the Nth highest value",
    "core": true,
    "alsoIn": [
      "argmax"
    ],
    "uses": 5
  },
  {
    "skill": "LEFT",
    "gloss": "The first n characters",
    "slug": "text-parse",
    "level": 1,
    "levelName": "The first few characters",
    "core": true,
    "alsoIn": [
      "sprint-text-basic"
    ],
    "uses": 4
  },
  {
    "skill": "LEN",
    "gloss": "How many characters long is this",
    "slug": "find-startnum",
    "level": 7,
    "levelName": "How many, not where",
    "core": true,
    "alsoIn": [
      "sprint-explode",
      "sprint-substitute",
      "sprint-text-basic",
      "text-parse"
    ],
    "uses": 9
  },
  {
    "skill": "LET",
    "gloss": "Name a piece of a formula so you can reuse it and read it",
    "slug": "let-byrow",
    "level": 1,
    "levelName": "LET: name it once, use it once",
    "core": true,
    "alsoIn": [
      "scan",
      "sprint-grid-distance",
      "sprint-wrap"
    ],
    "uses": 12
  },
  {
    "skill": "LOOKUP",
    "gloss": "Find the last value less than or equal to what you asked for",
    "slug": "index-match",
    "level": 9,
    "levelName": "Every bracket, every order",
    "core": true,
    "alsoIn": [],
    "uses": 2
  },
  {
    "skill": "MATCH",
    "gloss": "Which position in this list holds the thing I am looking for",
    "slug": "index-match",
    "level": 2,
    "levelName": "MATCH to find the row",
    "core": true,
    "alsoIn": [
      "argmax",
      "indirect",
      "sort-large",
      "sprint-arrays-2",
      "sprint-arrays-3",
      "sprint-index2d",
      "sprint-lookup-1",
      "sprint-lookup-2",
      "time-windows"
    ],
    "uses": 31
  },
  {
    "skill": "MAX",
    "gloss": "The biggest value",
    "slug": "argmax",
    "level": 1,
    "levelName": "The winning number",
    "core": false,
    "alsoIn": [
      "find-startnum",
      "sprint-arrays-2",
      "sprint-arrays-3",
      "sprint-find",
      "sprint-reduce",
      "sumifs",
      "time-windows"
    ],
    "uses": 23
  },
  {
    "skill": "MAXIFS",
    "gloss": "The biggest value among the rows that meet several conditions",
    "slug": "sprint-ifs-family",
    "level": 4,
    "levelName": "The spread between best and worst",
    "core": true,
    "alsoIn": [],
    "uses": 1
  },
  {
    "skill": "MID",
    "gloss": "n characters starting from a position you choose",
    "slug": "text-parse",
    "level": 3,
    "levelName": "A piece from the middle",
    "core": true,
    "alsoIn": [
      "sprint-explode",
      "sprint-text-basic"
    ],
    "uses": 7
  },
  {
    "skill": "MIN",
    "gloss": "The smallest value",
    "slug": "sprint-reduce",
    "level": 3,
    "levelName": "A battery that cannot overfill",
    "core": false,
    "alsoIn": [
      "sprint-grid-distance"
    ],
    "uses": 3
  },
  {
    "skill": "MINIFS",
    "gloss": "The smallest value among the rows that meet several conditions",
    "slug": "sprint-ifs-family",
    "level": 4,
    "levelName": "The spread between best and worst",
    "core": true,
    "alsoIn": [],
    "uses": 1
  },
  {
    "skill": "named-ranges",
    "gloss": "Give a range a name and use the name instead of the address",
    "slug": "indirect",
    "level": 7,
    "levelName": "A name is text too",
    "core": false,
    "alsoIn": [],
    "uses": 1
  },
  {
    "skill": "OFFSET",
    "gloss": "Start at a cell and step a given number of rows and columns from it",
    "slug": "sprint-offset",
    "level": 1,
    "levelName": "Move from the corner",
    "core": true,
    "alsoIn": [],
    "uses": 4
  },
  {
    "skill": "REDUCE",
    "gloss": "Fold a whole list down to one answer, carrying a result as you go",
    "slug": "sprint-reduce",
    "level": 1,
    "levelName": "Carry a total across the row",
    "core": true,
    "alsoIn": [],
    "uses": 4
  },
  {
    "skill": "RIGHT",
    "gloss": "The last n characters",
    "slug": "text-parse",
    "level": 2,
    "levelName": "The last few characters",
    "core": true,
    "alsoIn": [
      "sprint-text-basic"
    ],
    "uses": 4
  },
  {
    "skill": "ROUND",
    "gloss": "Round to a given number of decimal places",
    "slug": "sprint-ifs-family",
    "level": 3,
    "levelName": "The average, to the nearest whole",
    "core": false,
    "alsoIn": [],
    "uses": 1
  },
  {
    "skill": "SCAN",
    "gloss": "Carry a running total, or any running state, down a list in one formula",
    "slug": "scan",
    "level": 1,
    "levelName": "The last value of a running total",
    "core": true,
    "alsoIn": [],
    "uses": 10
  },
  {
    "skill": "SEQUENCE",
    "gloss": "Manufacture a list of numbers without typing them",
    "slug": "datatable-sequence",
    "level": 1,
    "levelName": "Does the model work at all",
    "core": false,
    "alsoIn": [
      "sprint-wrap"
    ],
    "uses": 5
  },
  {
    "skill": "SMALL",
    "gloss": "The nth smallest value",
    "slug": "sort-large",
    "level": 2,
    "levelName": "SMALL: the Nth lowest value",
    "core": true,
    "alsoIn": [],
    "uses": 2
  },
  {
    "skill": "SORT",
    "gloss": "Put an array in order without a helper column",
    "slug": "sort-sortby",
    "level": 1,
    "levelName": "SORT one column, lowest first",
    "core": true,
    "alsoIn": [
      "sb-every-xth",
      "sort-large",
      "sprint-arrays-1",
      "sprint-arrays-2",
      "sprint-arrays-3",
      "sprint-sort-1a",
      "sprint-sort-2a",
      "sprint-sort-3a",
      "sprint-sort-4a",
      "sprint-wrap"
    ],
    "uses": 22
  },
  {
    "skill": "SORTBY",
    "gloss": "Sort one list by the values in another",
    "slug": "sort-sortby",
    "level": 5,
    "levelName": "SORTBY: sort by columns you do not return",
    "core": true,
    "alsoIn": [
      "sort-large",
      "sprint-sort-2a",
      "sprint-sort-3a",
      "sprint-sort-4a"
    ],
    "uses": 15
  },
  {
    "skill": "SUBSTITUTE",
    "gloss": "Replace text, and subtracted from LEN, count how often it occurred",
    "slug": "sprint-substitute",
    "level": 1,
    "levelName": "Take the dashes out",
    "core": true,
    "alsoIn": [
      "find-startnum",
      "text-parse"
    ],
    "uses": 9
  },
  {
    "skill": "SUM",
    "gloss": "Add it up",
    "slug": "sumifs",
    "level": 1,
    "levelName": "Just add it all up",
    "core": false,
    "alsoIn": [
      "datatable-sequence",
      "sb-every-xth",
      "sprint-indirect",
      "sprint-lookup-3",
      "sprint-offset",
      "sprint-wrap",
      "sprint-xlookup-2a",
      "sprint-xlookup-4a"
    ],
    "uses": 20
  },
  {
    "skill": "SUMIFS",
    "gloss": "Add up only the rows that meet several conditions",
    "slug": "sumifs",
    "level": 2,
    "levelName": "One condition, but now you are adding",
    "core": true,
    "alsoIn": [
      "argmax",
      "sort-sortby",
      "sprint-arrays-3",
      "sprint-ifs-family",
      "sprint-sort-4a",
      "time-windows"
    ],
    "uses": 29
  },
  {
    "skill": "SUMPRODUCT",
    "gloss": "Multiply lists together and add the result, the classic array workhorse",
    "slug": "sumproduct",
    "level": 1,
    "levelName": "A plain dot product",
    "core": true,
    "alsoIn": [
      "argmax",
      "countifs",
      "index-match",
      "sort-large",
      "sprint-grid-distance",
      "sprint-transpose",
      "sumifs",
      "text-modern",
      "time-windows",
      "xlookup"
    ],
    "uses": 39
  },
  {
    "skill": "TAKE",
    "gloss": "The first or last few rows or columns of an array",
    "slug": "sort-large",
    "level": 7,
    "levelName": "Top-N sum, the modern way",
    "core": true,
    "alsoIn": [
      "scan",
      "sprint-sort-4a"
    ],
    "uses": 5
  },
  {
    "skill": "TEXTAFTER",
    "gloss": "Everything after a delimiter you name, not just the next field",
    "slug": "sprint-textbefore-after",
    "level": 2,
    "levelName": "What is behind, all of it",
    "core": true,
    "alsoIn": [
      "text-modern"
    ],
    "uses": 8
  },
  {
    "skill": "TEXTBEFORE",
    "gloss": "Everything in front of a delimiter you name, with no counting",
    "slug": "sprint-textbefore-after",
    "level": 1,
    "levelName": "What is in front",
    "core": true,
    "alsoIn": [
      "text-modern"
    ],
    "uses": 6
  },
  {
    "skill": "TEXTJOIN",
    "gloss": "Join a set of pieces with a separator, optionally skipping the empty ones",
    "slug": "sprint-join",
    "level": 4,
    "levelName": "With something in between",
    "core": true,
    "alsoIn": [
      "text-modern"
    ],
    "uses": 2
  },
  {
    "skill": "TEXTSPLIT",
    "gloss": "Break a string into all of its fields at once, spilled across cells",
    "slug": "sprint-textsplit",
    "level": 1,
    "levelName": "Reach into what it spills",
    "core": true,
    "alsoIn": [
      "text-modern"
    ],
    "uses": 7
  },
  {
    "skill": "TIME",
    "gloss": "Build a time from an hour, a minute and a second",
    "slug": "time-windows",
    "level": 2,
    "levelName": "How long until closing",
    "core": true,
    "alsoIn": [
      "argmax",
      "countifs",
      "sumifs"
    ],
    "uses": 16
  },
  {
    "skill": "TOCOL",
    "gloss": "Flatten a grid into one column, reading across or down, optionally skipping blanks",
    "slug": "sb-every-xth",
    "level": 1,
    "levelName": "TOCOL reads across",
    "core": true,
    "alsoIn": [
      "sprint-wrap"
    ],
    "uses": 10
  },
  {
    "skill": "TRANSPOSE",
    "gloss": "Turn a column into a row, or a row into a column",
    "slug": "sprint-transpose",
    "level": 1,
    "levelName": "Read the grid flipped",
    "core": true,
    "alsoIn": [],
    "uses": 4
  },
  {
    "skill": "TRIM",
    "gloss": "Strip stray spaces, including doubled ones inside the text",
    "slug": "text-parse",
    "level": 5,
    "levelName": "Clean it first",
    "core": true,
    "alsoIn": [],
    "uses": 1
  },
  {
    "skill": "UNIQUE",
    "gloss": "The distinct values, with duplicates removed",
    "slug": "unique-filter",
    "level": 3,
    "levelName": "UNIQUE keeps first-seen order",
    "core": true,
    "alsoIn": [
      "sprint-arrays-1",
      "sprint-arrays-2",
      "sprint-arrays-3"
    ],
    "uses": 10
  },
  {
    "skill": "VALUE",
    "gloss": "Turn text that looks like a number into a real number",
    "slug": "text-parse",
    "level": 8,
    "levelName": "The blank that breaks everything",
    "core": true,
    "alsoIn": [
      "sprint-explode",
      "sprint-text-basic",
      "text-modern"
    ],
    "uses": 6
  },
  {
    "skill": "WRAPCOLS",
    "gloss": "Cut a list into columns of a chosen height (every xth item lines up in one row)",
    "slug": "sb-every-xth",
    "level": 4,
    "levelName": "Down the columns with WRAPCOLS",
    "core": true,
    "alsoIn": [
      "sprint-wrap"
    ],
    "uses": 2
  },
  {
    "skill": "WRAPROWS",
    "gloss": "Cut a list into rows of a chosen length (every xth item lines up in one column)",
    "slug": "sb-every-xth",
    "level": 3,
    "levelName": "WRAPROWS takes every xth",
    "core": true,
    "alsoIn": [
      "sprint-wrap"
    ],
    "uses": 6
  },
  {
    "skill": "XLOOKUP",
    "gloss": "Look something up in any direction, with a fallback when it is missing",
    "slug": "xlookup",
    "level": 1,
    "levelName": "Exact match",
    "core": true,
    "alsoIn": [
      "sort-sortby",
      "sprint-lookup-1",
      "sprint-lookup-2",
      "sprint-lookup-3",
      "sprint-sort-2a",
      "sprint-sort-3a",
      "sprint-sort-4a",
      "sprint-xlookup-1a",
      "sprint-xlookup-2a",
      "sprint-xlookup-3a",
      "sprint-xlookup-4a"
    ],
    "uses": 40
  },
  {
    "skill": "XMATCH",
    "gloss": "Which position matches, including the first one over a threshold",
    "slug": "scan",
    "level": 4,
    "levelName": "Where the series crosses a line",
    "core": true,
    "alsoIn": [
      "sort-sortby",
      "sprint-sort-4a"
    ],
    "uses": 4
  }
];

export const GUIDE_CARDS = [
  {
    "slug": "find-startnum",
    "title": "FIND: Searching Onward From a Position",
    "tier": 1,
    "kind": "atom",
    "questions": 62,
    "points": 1000,
    "teaches": [
      "CHAR",
      "FIND",
      "LEN",
      "SUBSTITUTE"
    ],
    "verdict": "Start here. This challenge uses nothing beyond everyday Excel and the functions it teaches you.",
    "open": true,
    "levels": [
      {
        "n": 1,
        "name": "Where is the first one",
        "shown": true
      },
      {
        "n": 2,
        "name": "FIND is case-sensitive, SEARCH is not",
        "shown": true
      },
      {
        "n": 3,
        "name": "The second one",
        "shown": true
      },
      {
        "n": 4,
        "name": "The Nth one, without nesting forever",
        "shown": true
      },
      {
        "n": 5,
        "name": "The first B that comes after an A",
        "shown": true
      },
      {
        "n": 6,
        "name": "Three chains at once",
        "shown": true
      },
      {
        "n": 7,
        "name": "How many, not where",
        "shown": true
      },
      {
        "n": 8,
        "name": "The LAST one",
        "shown": false
      },
      {
        "n": 9,
        "name": "How far apart",
        "shown": false
      },
      {
        "n": 10,
        "name": "When items stop being one character",
        "shown": false
      }
    ]
  },
  {
    "slug": "indirect",
    "title": "INDIRECT: Addresses You Build Yourself",
    "tier": 1,
    "kind": "atom",
    "questions": 62,
    "points": 1000,
    "teaches": [
      "ADDRESS",
      "INDIRECT"
    ],
    "verdict": "Beginner-safe. Levels 1 to 7 need nothing but what this challenge teaches; from Level 8 it also uses MATCH, covered in ch.index-match.",
    "open": true,
    "levels": [
      {
        "n": 1,
        "name": "Text into a reference",
        "shown": true
      },
      {
        "n": 2,
        "name": "When all you have is numbers",
        "shown": true
      },
      {
        "n": 3,
        "name": "A range whose ends move",
        "shown": true
      },
      {
        "n": 4,
        "name": "A rectangle",
        "shown": true
      },
      {
        "n": 5,
        "name": "Another sheet, chosen while it runs",
        "shown": true
      },
      {
        "n": 6,
        "name": "R1C1, and the argument nobody uses",
        "shown": true
      },
      {
        "n": 7,
        "name": "A name is text too",
        "shown": true
      },
      {
        "n": 8,
        "name": "Find the row first",
        "shown": false
      },
      {
        "n": 9,
        "name": "The cell that holds an address",
        "shown": false
      },
      {
        "n": 10,
        "name": "Bounds that live in the sheet",
        "shown": false
      }
    ]
  },
  {
    "slug": "xlookup",
    "title": "XLOOKUP: One Function, Any Direction",
    "tier": 1,
    "kind": "atom",
    "questions": 62,
    "points": 1000,
    "teaches": [
      "XLOOKUP",
      "XMATCH"
    ],
    "verdict": "Beginner-safe. Levels 1 to 7 need nothing but what this challenge teaches; from Level 8 it also uses IFERROR, LEFT and SUMPRODUCT, covered in ch.text-parse and ch.sumproduct.",
    "open": true,
    "levels": [
      {
        "n": 1,
        "name": "Exact match",
        "shown": true
      },
      {
        "n": 2,
        "name": "Returning text",
        "shown": true
      },
      {
        "n": 3,
        "name": "When there is nothing to find",
        "shown": true
      },
      {
        "n": 4,
        "name": "An approximate match, on purpose",
        "shown": true
      },
      {
        "n": 5,
        "name": "Searching from the bottom",
        "shown": true
      },
      {
        "n": 6,
        "name": "Two dimensions at once",
        "shown": true
      },
      {
        "n": 7,
        "name": "Bringing back more than one cell",
        "shown": true
      },
      {
        "n": 8,
        "name": "Every gold, silver and bronze order",
        "shown": false
      },
      {
        "n": 9,
        "name": "Every bracket, every order",
        "shown": false
      },
      {
        "n": 10,
        "name": "Both discounts, one formula",
        "shown": false
      }
    ]
  },
  {
    "slug": "index-match",
    "title": "INDEX and MATCH: The Classic Two-Way Lookup",
    "tier": 1,
    "kind": "combo",
    "questions": 62,
    "points": 1000,
    "teaches": [
      "INDEX",
      "LOOKUP",
      "MATCH"
    ],
    "verdict": "Beginner-safe. Levels 1 to 6 need nothing but what this challenge teaches; from Level 7 it also uses COUNTIFS, IFERROR, LEFT and SUMPRODUCT, covered in ch.countifs, ch.text-parse and ch.sumproduct.",
    "open": true,
    "levels": [
      {
        "n": 1,
        "name": "INDEX with a row number",
        "shown": true
      },
      {
        "n": 2,
        "name": "MATCH to find the row",
        "shown": true
      },
      {
        "n": 3,
        "name": "The pair together",
        "shown": true
      },
      {
        "n": 4,
        "name": "MATCH, approximately",
        "shown": true
      },
      {
        "n": 5,
        "name": "Two dimensions at once",
        "shown": true
      },
      {
        "n": 6,
        "name": "INDEX returning a whole row",
        "shown": true
      },
      {
        "n": 7,
        "name": "A tier hiding inside the code",
        "shown": true
      },
      {
        "n": 8,
        "name": "Every gold, silver and bronze order",
        "shown": false
      },
      {
        "n": 9,
        "name": "Every bracket, every order",
        "shown": false
      },
      {
        "n": 10,
        "name": "Both discounts, one formula",
        "shown": false
      }
    ]
  },
  {
    "slug": "argmax",
    "title": "ARGMAX: Aggregate, Then Name the Winner",
    "tier": 1,
    "kind": "combo",
    "questions": 62,
    "points": 1000,
    "teaches": [
      "COUNTIFS",
      "INDEX",
      "LARGE",
      "MATCH",
      "SUMIFS",
      "SUMPRODUCT"
    ],
    "verdict": "Beginner-safe. Levels 1 to 6 need nothing but what this challenge teaches; from Level 7 it also uses INDIRECT, ROW and TIME, covered in ch.indirect and ch.time-windows.",
    "open": true,
    "levels": [
      {
        "n": 1,
        "name": "The winning number",
        "shown": true
      },
      {
        "n": 2,
        "name": "The winning name",
        "shown": true
      },
      {
        "n": 3,
        "name": "Change what you group by",
        "shown": true
      },
      {
        "n": 4,
        "name": "Group by day",
        "shown": true
      },
      {
        "n": 5,
        "name": "Count instead of sum",
        "shown": true
      },
      {
        "n": 6,
        "name": "An average, not a total",
        "shown": true
      },
      {
        "n": 7,
        "name": "When the list does not exist yet",
        "shown": true
      },
      {
        "n": 8,
        "name": "Winner inside a slice",
        "shown": false
      },
      {
        "n": 9,
        "name": "Not the winner, the runner-up",
        "shown": false
      },
      {
        "n": 10,
        "name": "Everything moves at once",
        "shown": false
      }
    ]
  },
  {
    "slug": "countifs",
    "title": "COUNTIF and COUNTIFS: Counting With Conditions",
    "tier": 2,
    "kind": "atom",
    "questions": 62,
    "points": 1000,
    "teaches": [
      "COUNTIF",
      "COUNTIFS"
    ],
    "verdict": "Beginner-safe. Levels 1 to 4 need nothing but what this challenge teaches; from Level 5 it also uses SUMPRODUCT and TIME, covered in ch.sumproduct and ch.time-windows.",
    "open": true,
    "levels": [
      {
        "n": 1,
        "name": "One condition",
        "shown": true
      },
      {
        "n": 2,
        "name": "A condition that is not equals",
        "shown": true
      },
      {
        "n": 3,
        "name": "Two conditions",
        "shown": true
      },
      {
        "n": 4,
        "name": "Between two numbers",
        "shown": true
      },
      {
        "n": 5,
        "name": "A window of time",
        "shown": true
      },
      {
        "n": 6,
        "name": "Starts with",
        "shown": true
      },
      {
        "n": 7,
        "name": "Blank, and not blank",
        "shown": true
      },
      {
        "n": 8,
        "name": "How many DIFFERENT ones",
        "shown": false
      },
      {
        "n": 9,
        "name": "Counting the groups, not the rows",
        "shown": false
      },
      {
        "n": 10,
        "name": "Everything at once",
        "shown": false
      }
    ]
  },
  {
    "slug": "sumifs",
    "title": "SUMIFS: Adding With Conditions",
    "tier": 2,
    "kind": "atom",
    "questions": 62,
    "points": 1000,
    "teaches": [
      "SUMIFS"
    ],
    "verdict": "Beginner-safe. Levels 1 to 5 need nothing but what this challenge teaches; from Level 6 it also uses SUMPRODUCT and TIME, covered in ch.sumproduct and ch.time-windows.",
    "open": true,
    "levels": [
      {
        "n": 1,
        "name": "Just add it all up",
        "shown": true
      },
      {
        "n": 2,
        "name": "One condition, but now you are adding",
        "shown": true
      },
      {
        "n": 3,
        "name": "Two conditions",
        "shown": true
      },
      {
        "n": 4,
        "name": "Three conditions, all at once",
        "shown": true
      },
      {
        "n": 5,
        "name": "A window on Qty",
        "shown": true
      },
      {
        "n": 6,
        "name": "A window on Time",
        "shown": true
      },
      {
        "n": 7,
        "name": "The best of a group",
        "shown": true
      },
      {
        "n": 8,
        "name": "The best of a group, before a time",
        "shown": false
      },
      {
        "n": 9,
        "name": "One item, a Qty window",
        "shown": false
      },
      {
        "n": 10,
        "name": "Item, Qty, and a time window, together",
        "shown": false
      }
    ]
  },
  {
    "slug": "sumproduct",
    "title": "SUMPRODUCT: Multiply, Then Add, All At Once",
    "tier": 2,
    "kind": "atom",
    "questions": 62,
    "points": 1000,
    "teaches": [
      "SUMPRODUCT"
    ],
    "verdict": "Beginner-safe. Levels 1 to 7 need nothing but what this challenge teaches; from Level 8 it also uses COUNTIFS, IFERROR, LEFT, RIGHT, TIME, TRANSPOSE and VALUE, covered in ch.countifs, ch.text-parse, ch.time-windows and ch.sprint-transpose.",
    "open": true,
    "levels": [
      {
        "n": 1,
        "name": "A plain dot product",
        "shown": true
      },
      {
        "n": 2,
        "name": "A conditional counter",
        "shown": true
      },
      {
        "n": 3,
        "name": "AND with a star",
        "shown": true
      },
      {
        "n": 4,
        "name": "OR with a plus",
        "shown": true
      },
      {
        "n": 5,
        "name": "Forcing the coercion",
        "shown": true
      },
      {
        "n": 6,
        "name": "A weight, not just 0 or 1",
        "shown": true
      },
      {
        "n": 7,
        "name": "Composed",
        "shown": true
      },
      {
        "n": 8,
        "name": "Feed it two lists",
        "shown": false
      },
      {
        "n": 9,
        "name": "A window, blank-safe",
        "shown": false
      },
      {
        "n": 10,
        "name": "Everything composed",
        "shown": false
      }
    ]
  },
  {
    "slug": "text-parse",
    "title": "LEFT, RIGHT, MID, LEN, VALUE, FIND, SUBSTITUTE, TRIM: Taking Text Apart",
    "tier": 2,
    "kind": "atom",
    "questions": 62,
    "points": 1000,
    "teaches": [
      "FIND",
      "ISNUMBER",
      "LEFT",
      "LEN",
      "MID",
      "RIGHT",
      "SUBSTITUTE",
      "TRIM",
      "VALUE"
    ],
    "verdict": "Beginner-safe. Levels 1 to 7 need nothing but what this challenge teaches; from Level 8 it also uses IFERROR and SUMPRODUCT, covered in ch.sumproduct.",
    "open": true,
    "levels": [
      {
        "n": 1,
        "name": "The first few characters",
        "shown": true
      },
      {
        "n": 2,
        "name": "The last few characters",
        "shown": true
      },
      {
        "n": 3,
        "name": "A piece from the middle",
        "shown": true
      },
      {
        "n": 4,
        "name": "How long is it",
        "shown": true
      },
      {
        "n": 5,
        "name": "Clean it first",
        "shown": true
      },
      {
        "n": 6,
        "name": "Where is it",
        "shown": true
      },
      {
        "n": 7,
        "name": "Counting, not finding",
        "shown": true
      },
      {
        "n": 8,
        "name": "The blank that breaks everything",
        "shown": false
      },
      {
        "n": 9,
        "name": "Tier into dollars",
        "shown": false
      },
      {
        "n": 10,
        "name": "Everything at once",
        "shown": false
      }
    ]
  },
  {
    "slug": "unique-filter",
    "title": "UNIQUE and FILTER: Pulling Out the Rows That Match",
    "tier": 2,
    "kind": "combo",
    "questions": 62,
    "points": 1000,
    "teaches": [
      "FILTER",
      "UNIQUE"
    ],
    "verdict": "You can open this cold, but not get far: INDEX arrives at Level 3, which ch.index-match covers.",
    "open": true,
    "levels": [
      {
        "n": 1,
        "name": "FILTER: pull the rows, then total them",
        "shown": true
      },
      {
        "n": 2,
        "name": "FILTER: when nothing matches",
        "shown": true
      },
      {
        "n": 3,
        "name": "UNIQUE keeps first-seen order",
        "shown": true
      },
      {
        "n": 4,
        "name": "COUNTA(UNIQUE(...)): counting DIFFERENT things",
        "shown": true
      },
      {
        "n": 5,
        "name": "Naming the AND: multiply the arrays",
        "shown": true
      },
      {
        "n": 6,
        "name": "FILTER with OR: add the arrays instead",
        "shown": true
      },
      {
        "n": 7,
        "name": "A distinct PAIR: join the columns first",
        "shown": true
      },
      {
        "n": 8,
        "name": "A pair, with a threshold folded in",
        "shown": false
      },
      {
        "n": 9,
        "name": "OR inside an AND",
        "shown": false
      },
      {
        "n": 10,
        "name": "Everything at once: pairs, OR, AND, not-blank",
        "shown": false
      }
    ]
  },
  {
    "slug": "scan",
    "title": "SCAN: Running State in One Formula",
    "tier": 2,
    "kind": "atom",
    "questions": 62,
    "points": 1000,
    "teaches": [
      "CHOOSECOLS",
      "LAMBDA",
      "SCAN",
      "TAKE",
      "XMATCH"
    ],
    "verdict": "Beginner-safe. Levels 1 to 9 need nothing but what this challenge teaches; from Level 10 it also uses LET, covered in ch.let-byrow.",
    "open": true,
    "levels": [
      {
        "n": 1,
        "name": "The last value of a running total",
        "shown": true
      },
      {
        "n": 2,
        "name": "Reading one day out of the series",
        "shown": true
      },
      {
        "n": 3,
        "name": "The peak of the running series",
        "shown": true
      },
      {
        "n": 4,
        "name": "Where the series crosses a line",
        "shown": true
      },
      {
        "n": 5,
        "name": "Counting over the series",
        "shown": true
      },
      {
        "n": 6,
        "name": "Putting logic inside the lambda",
        "shown": true
      },
      {
        "n": 7,
        "name": "State that resets",
        "shown": true
      },
      {
        "n": 8,
        "name": "An accumulator that multiplies",
        "shown": false
      },
      {
        "n": 9,
        "name": "Clamped on both sides",
        "shown": false
      },
      {
        "n": 10,
        "name": "Naming the series so you build it once",
        "shown": false
      }
    ]
  },
  {
    "slug": "let-byrow",
    "title": "LET and BYROW: A Discount Rule, Run Once Per Order",
    "tier": 2,
    "kind": "combo",
    "questions": 62,
    "points": 1000,
    "teaches": [
      "BYROW",
      "HSTACK",
      "LAMBDA",
      "LET"
    ],
    "verdict": "You can open this cold, but not get far: HOUR, INDEX, LEFT and MATCH arrive at Level 3, which ch.time-windows, ch.index-match and ch.text-parse cover.",
    "open": true,
    "levels": [
      {
        "n": 1,
        "name": "LET: name it once, use it once",
        "shown": true
      },
      {
        "n": 2,
        "name": "LET with several names",
        "shown": true
      },
      {
        "n": 3,
        "name": "LET, sourced from the real data",
        "shown": true
      },
      {
        "n": 4,
        "name": "BYROW: the LAMBDA runs once per row",
        "shown": true
      },
      {
        "n": 5,
        "name": "The full discount, once per order",
        "shown": true
      },
      {
        "n": 6,
        "name": "Counting over a computed array",
        "shown": true
      },
      {
        "n": 7,
        "name": "Counted, then subtracted",
        "shown": true
      },
      {
        "n": 8,
        "name": "Two arrays, built from the same filter",
        "shown": false
      },
      {
        "n": 9,
        "name": "Two full pipelines, subtracted",
        "shown": false
      },
      {
        "n": 10,
        "name": "Everything at once",
        "shown": false
      }
    ]
  },
  {
    "slug": "time-windows",
    "title": "TIME: Before, Between, and the Best Window",
    "tier": 3,
    "kind": "atom",
    "questions": 74,
    "points": 1060,
    "teaches": [
      "HOUR",
      "TIME"
    ],
    "verdict": "You can open this cold, but not get far: COUNTIFS arrives at Level 3, which ch.countifs covers.",
    "open": true,
    "levels": [
      {
        "n": 1,
        "name": "What hour is this",
        "shown": true
      },
      {
        "n": 2,
        "name": "How long until closing",
        "shown": true
      },
      {
        "n": 3,
        "name": "Before a given time",
        "shown": true
      },
      {
        "n": 4,
        "name": "A half-open window",
        "shown": true
      },
      {
        "n": 5,
        "name": "Revenue in that same window",
        "shown": true
      },
      {
        "n": 6,
        "name": "Pulling the hour back out",
        "shown": true
      },
      {
        "n": 7,
        "name": "The best single hour, for one day",
        "shown": true
      },
      {
        "n": 8,
        "name": "WHICH hour earns the most",
        "shown": true
      },
      {
        "n": 9,
        "name": "The best window of a given width",
        "shown": true
      },
      {
        "n": 10,
        "name": "WHERE the best window starts",
        "shown": false
      },
      {
        "n": 11,
        "name": "The best window, for one barista",
        "shown": false
      },
      {
        "n": 12,
        "name": "The best window's revenue, for one payment method",
        "shown": false
      }
    ]
  },
  {
    "slug": "sort-large",
    "title": "LARGE, SMALL, and Sorting a Row Without a Helper Column",
    "tier": 3,
    "kind": "atom",
    "questions": 62,
    "points": 1000,
    "teaches": [
      "LARGE",
      "SMALL",
      "SORT",
      "SORTBY",
      "TAKE"
    ],
    "verdict": "You can open this cold, but not get far: INDIRECT, ROW and SUMPRODUCT arrive at Level 3, which ch.indirect and ch.sumproduct cover.",
    "open": true,
    "levels": [
      {
        "n": 1,
        "name": "LARGE: the Nth highest value",
        "shown": true
      },
      {
        "n": 2,
        "name": "SMALL: the Nth lowest value",
        "shown": true
      },
      {
        "n": 3,
        "name": "Top-N sum, the classic way",
        "shown": true
      },
      {
        "n": 4,
        "name": "The value versus the thing that has it",
        "shown": true
      },
      {
        "n": 5,
        "name": "SORT needs to be told which way is 'across'",
        "shown": true
      },
      {
        "n": 6,
        "name": "SORTBY: sort one array by another",
        "shown": true
      },
      {
        "n": 7,
        "name": "Top-N sum, the modern way",
        "shown": true
      },
      {
        "n": 8,
        "name": "LARGE and SMALL, combined",
        "shown": false
      },
      {
        "n": 9,
        "name": "The gap between two consecutive places",
        "shown": false
      },
      {
        "n": 10,
        "name": "Everyone who outsold a given place",
        "shown": false
      }
    ]
  },
  {
    "slug": "text-modern",
    "title": "TEXTBEFORE, TEXTAFTER, TEXTSPLIT, TEXTJOIN: Taking Text Apart the Modern Way",
    "tier": 2,
    "kind": "atom",
    "questions": 62,
    "points": 1000,
    "teaches": [
      "COLUMNS",
      "TEXTAFTER",
      "TEXTBEFORE",
      "TEXTJOIN",
      "TEXTSPLIT"
    ],
    "verdict": "Beginner-safe. Levels 1 to 6 need nothing but what this challenge teaches; from Level 7 it also uses IFERROR, INDEX, SUMPRODUCT and VALUE, covered in ch.index-match, ch.sumproduct and ch.text-parse.",
    "open": true,
    "levels": [
      {
        "n": 1,
        "name": "In front of the first dash",
        "shown": true
      },
      {
        "n": 2,
        "name": "Behind it, all of it",
        "shown": true
      },
      {
        "n": 3,
        "name": "Cut at the one you name",
        "shown": true
      },
      {
        "n": 4,
        "name": "Exactly one field out of the middle",
        "shown": true
      },
      {
        "n": 5,
        "name": "The last one, without counting",
        "shown": true
      },
      {
        "n": 6,
        "name": "How many fields are there",
        "shown": true
      },
      {
        "n": 7,
        "name": "Field n, in one cut",
        "shown": true
      },
      {
        "n": 8,
        "name": "Put it back together",
        "shown": false
      },
      {
        "n": 9,
        "name": "The same cut, on all 200 rows",
        "shown": false
      },
      {
        "n": 10,
        "name": "The void that breaks everything",
        "shown": false
      }
    ]
  },
  {
    "slug": "sort-sortby",
    "title": "SORT and SORTBY: Putting Rows in Order, Then Reaching In",
    "tier": 2,
    "kind": "combo",
    "questions": 62,
    "points": 1000,
    "teaches": [
      "SORT",
      "SORTBY"
    ],
    "verdict": "Not a starting point. Level 1 already uses INDEX, so work through ch.index-match first.",
    "open": false,
    "levels": [
      {
        "n": 1,
        "name": "SORT one column, lowest first",
        "shown": true
      },
      {
        "n": 2,
        "name": "SORT one column, highest first",
        "shown": true
      },
      {
        "n": 3,
        "name": "SORT a table by one of its columns",
        "shown": true
      },
      {
        "n": 4,
        "name": "Break a tie with a second key",
        "shown": true
      },
      {
        "n": 5,
        "name": "SORTBY: sort by columns you do not return",
        "shown": true
      },
      {
        "n": 6,
        "name": "SORTBY a value that is not on the sheet",
        "shown": true
      },
      {
        "n": 7,
        "name": "FILTER first, then SORT",
        "shown": true
      },
      {
        "n": 8,
        "name": "SORTBY across a row",
        "shown": false
      },
      {
        "n": 9,
        "name": "Where do you finish? XMATCH into a sorted list",
        "shown": false
      },
      {
        "n": 10,
        "name": "Aggregate the groups, THEN sort them",
        "shown": false
      }
    ]
  },
  {
    "slug": "sb-every-xth",
    "title": "Skill Builder: Every Xth Number (Bonus 3)",
    "tier": 2,
    "kind": "combo",
    "questions": 120,
    "points": 1300,
    "teaches": [
      "CHOOSECOLS",
      "CHOOSEROWS",
      "TOCOL",
      "WRAPCOLS",
      "WRAPROWS"
    ],
    "verdict": "Not a starting point. Level 1 already uses INDEX, so work through ch.index-match first.",
    "open": false,
    "levels": [
      {
        "n": 1,
        "name": "TOCOL reads across",
        "shown": true
      },
      {
        "n": 2,
        "name": "TOCOL reads down",
        "shown": true
      },
      {
        "n": 3,
        "name": "WRAPROWS takes every xth",
        "shown": true
      },
      {
        "n": 4,
        "name": "Down the columns with WRAPCOLS",
        "shown": false
      },
      {
        "n": 5,
        "name": "Sort first: the Bonus 3 move",
        "shown": false
      },
      {
        "n": 6,
        "name": "Mind the gaps: skip blanks or not",
        "shown": false
      }
    ]
  }
];

export const GUIDE_CONCEPTS = [
  {
    "title": "Aggregate, then name the winner",
    "text": "MAX tells you the best number. It never tells you WHOSE it was. Pairing an aggregate with INDEX and MATCH is the single most common shape in competition Excel.",
    "slug": "argmax",
    "level": 2
  },
  {
    "title": "Half-open windows",
    "text": "Every window is >= on the bottom and < on the top. That asymmetry is what lets back-to-back windows tile a day without double-counting the boundary.",
    "slug": "time-windows",
    "level": 4
  },
  {
    "title": "Make an array out of nothing",
    "text": "ROW(INDIRECT(\"7:17\")) manufactures the numbers 7 to 17, so one SUMIFS can be asked for eleven totals at once. The pre-365 way to do what SEQUENCE does today.",
    "slug": "time-windows",
    "level": 7
  },
  {
    "title": "Count occurrences with LEN minus LEN",
    "text": "Delete every copy of a letter and see how much shorter the string got. That gap is the count. FIND only ever finds the first one.",
    "slug": "text-parse",
    "level": 7
  },
  {
    "title": "Search onward from a position",
    "text": "FIND's third argument is where to start. It is how you get the SECOND occurrence, and it removes the IF that most people reach for first.",
    "slug": "find-startnum",
    "level": 3
  },
  {
    "title": "Carry state down a list",
    "text": "A running total, a peak, a streak, a balance that cannot go below zero. All the same shape: an accumulator and a rule for updating it.",
    "slug": "scan",
    "level": 1
  },
  {
    "title": "When the data is not friendly, change the data",
    "text": "Find and Replace before you write the formula. Two-character tokens become one character, and a formula that was impossible becomes the one you already wrote.",
    "slug": "find-startnum",
    "level": 10
  }
];
